import { createSlice } from "@reduxjs/toolkit";

export const get_crops = createSlice({
  name: "crop_info_crop",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreCrops: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreCrops } = get_crops.actions;

export default get_crops.reducer;
